import React, { useState } from 'react';
import Web3RpcCalls from '../helpers/web3Config';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { docco } from 'react-syntax-highlighter/dist/esm/styles/hljs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopy } from '@fortawesome/free-solid-svg-icons'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'


const ResponseSample = ({
    web3Lib,
    args,
    currentMethod,
    hideCodeSample,
    url,
    visible,
    NodeResponse
}) => {

    const web3RequestTemplate =
        currentMethod &&
        web3Lib &&
        url &&
        Web3RpcCalls[currentMethod][web3Lib]['codeSample'](url, ...args);

    const web3ResponseTemplate =
        `{
    "jsonrpc": "2.0",
    "id": 1,
    "result": ${NodeResponse}
}`

    const [RequestIcon, setRequestIcon] = useState(faCopy);
    const [ResponseIcon, setResponseIcon] = useState(faCopy);


    return (
        <div>

            {/* Sample JSON Request */}

            <div class="card card-bordered mb-3">

                <div class="card-header">
                    <div class="col mb-2 mb-sm-0">
                        <h5 class="card-title">Request</h5>
                    </div>
                    <div class="col-auto ml-auto text-right">
                        <button type="button"
                            class="btn btn-ghost-dark btn-icon btn-xs shadow-none"
                            onClick={() => {
                                setRequestIcon(faCheckCircle)
                                navigator.clipboard.writeText(web3RequestTemplate)
                                setTimeout(() => {
                                    setRequestIcon(faCopy)
                                }, 2000);
                            }}>
                            <FontAwesomeIcon icon={RequestIcon} style={{ fontSize: 20, color: "#377dff" }} />
                        </button>
                    </div>
                </div>

                <div class="card-body">
                    <SyntaxHighlighter
                        language="json"
                        style={docco}
                        showLineNumbers={true}
                        wrapLines={true}
                        customStyle={{ fontSize: '16px' }}
                    >
                        {currentMethod ? web3RequestTemplate : "*Sample JSON request*"}
                    </SyntaxHighlighter>
                </div>

            </div>

            {/* Sample JSON Response */}

            <div class="card card-bordered mb-3">

                <div class="card-header">
                    <div class="col mb-2 mb-sm-0">
                        <h5 class="card-title">Response</h5>
                    </div>
                    <div class="col-auto ml-auto text-right">
                        <button type="button"
                            class="btn btn-ghost-dark btn-icon btn-xs shadow-none"
                            onClick={() => {
                                setResponseIcon(faCheckCircle)
                                navigator.clipboard.writeText(web3ResponseTemplate)
                                setTimeout(() => {
                                    setResponseIcon(faCopy)
                                }, 2000);
                            }}>
                            <FontAwesomeIcon icon={ResponseIcon} style={{ fontSize: 20, color: "#377dff" }} />
                        </button>
                    </div>
                </div>

                <div class="card-body">
                    <SyntaxHighlighter
                        language="json"
                        style={docco}
                        showLineNumbers={true}
                        wrapLines={false}
                        customStyle={{ fontSize: '16px' }}
                    >
                        {NodeResponse ? web3ResponseTemplate : "*Sample JSON response*"}
                    </SyntaxHighlighter>
                </div>
            </div>

        </div>
    );
}

export { ResponseSample };